import React from 'react';

import './map.css';
export default class Map extends React.Component{
    render(){
        
        return(
            <div className="map-container">
                <div id="map" className="col-xs-12 col-md-8">
                    <h2>Kapcsolat</h2>
                    <iframe title="gmap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2708.245271770587!2d16.92133131530702!3d47.25090697916275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47694ce6bf1a7d4d%3A0x189f66796c5329ae!2zU8OhcnbDoXIsIE9yc29seWEgdS4gMjIsIDk2MDA!5e0!3m2!1shu!2shu!4v1531331170597" width="100%" height="450px" frameBorder="none" allowFullScreen></iframe>
                </div>
            
                <div className="col-xs-12 col-md-4 contact">
                    <h4>Elérhetőségek</h4>
                    <p> Zsolnai Adél  </p>
                    <p className="contact-data">
                        <span className="ti-Line-Phone"></span>
                        +36 70/36 56 418 
                    </p>
                    <p className="contact-data">
                        <span className="ti-Line-Email"></span>
                        <a href="mailto:name@email.com">adelzsolnai@gmail.com</a> 
                    </p>

                   <h4 className="mt-50">English contact</h4> 
                   <p> Gábor Zsolnai  </p>
                   <p className="contact-data">
                        <span className="ti-Line-Phone"></span>
                        +36 20/91 24 553 
                    </p>
                    <p className="contact-data">
                        <span className="ti-Line-Email"></span>
                        <a href="mailto:name@email.com">zsolnai.gabor@gmail.com</a> 
                    </p>

                    <p className="ntak-number">
                        NTAK regisztrációs szám: MA19016965 - Apartman
                    </p>

                </div>
            <div className="clearfix"></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/content/map.js